import React from "react";
import {Property} from "csstype";

import type {INotification} from "../types/INotification";
import {Notification} from "./Notification";

import * as styles from "./Notifications.module.css";

interface IProps {
    inset?: Property.Inset;
    notifications: INotification[];
    removeNotification: (id: INotification["id"]) => void;
    zIndex?: Property.ZIndex;
}

export const Notifications = (props: IProps) => {
    return (
        <ul className={styles["notifications"]} style={{inset: props.inset || "1.6rem 1.6rem auto auto", zIndex: props.zIndex || 10002}}>
            {props.notifications.map((notification) => {
                return <Notification key={notification.id} notification={notification} removeNotification={() => props.removeNotification(notification.id)} />;
            })}
        </ul>
    );
};
import React from "react";
import {Property} from "csstype";

import type {INotification} from "../types/INotification";
import {Notification} from "./Notification";

import * as styles from "./Notifications.module.css";

interface IProps {
    inset?: Property.Inset;
    notifications: INotification[];
    removeNotification: (id: INotification["id"]) => void;
    zIndex?: Property.ZIndex;
}

export const Notifications = (props: IProps) => {
    return (
        <ul className={styles["notifications"]} style={{inset: props.inset || "1.6rem 1.6rem auto auto", zIndex: props.zIndex || 10002}}>
            {props.notifications.map((notification) => {
                return <Notification key={notification.id} notification={notification} removeNotification={() => props.removeNotification(notification.id)} />;
            })}
        </ul>
    );
};
